/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import getOr from 'lodash/fp/getOr.js';
import { CREATE_MODEL_FLOW } from '#reducers/ui/index.js';

// An array path, not an interpolated string: a string path would be re-parsed by lodash, so any
// '.', '[' or ']' in the id would silently address a different key.
export const selectCreateModelFlowStep = (state, modelId) =>
  getOr(null, ['ui', CREATE_MODEL_FLOW, modelId], state);
